import {createAction} from '@reduxjs/toolkit';

export const set = createAction('SELECTIONS_SET');
export const add = createAction('SELECTIONS_ADD');
export const remove = createAction('SELECTIONS_REMOVE');
